import axios from "axios";

// Create axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL ,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

const publicAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Flag to prevent multiple redirects
let isRedirecting = false;

export const setupInterceptors = (setLoading) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (setLoading) setLoading(true);
      if (config.data instanceof FormData) delete config.headers["Content-Type"];
      return config;
    },
    (error) => {
      if (setLoading) setLoading(false); //  stop loading on request error
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (setLoading) setLoading(false); //  stop loading on success
      return response;
    },
    (error) => {
      if (setLoading) setLoading(false); //  stop loading on error

      if (error.response?.status === 401) {

        if (!error.config.url.includes('/login')) {
          const currentPath = window.location.pathname;
          // Applicants (external candidates) belong on /empsignIn, not the
          // staff /signIn page. Detect via sessionStorage.candidateId.
          const isApplicant = !!sessionStorage.getItem("candidateId");
          const target = isApplicant ? "/empsignIn" : "/signIn";

        // 🔒 Prevent redirect loop
        if (!isRedirecting && currentPath !== target) {
          isRedirecting = true;
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace(target);
        }
        }

      }

      return Promise.reject(error);
    }
  );
};

// Example: helper methods remain unchanged
export const postData = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getData = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const putData = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteData = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Token utilities
export const tokenManager = {
  setToken: (token, rememberMe = false) => {
    if (rememberMe) localStorage.setItem("token", token);
    else sessionStorage.setItem("token", token);
    isRedirecting = false;
  },
  getToken: () => localStorage.getItem("token") || sessionStorage.getItem("token"),
  removeToken: () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    isRedirecting = false;
  },
  isAuthenticated: () => !!(localStorage.getItem("token") || sessionStorage.getItem("token")),
};

export { publicAxios };
export default axiosInstance;
